<script>
    import NauiSelect from "../../naui/atoms/NauiSelect.svelte";
    import {onMount} from "svelte";

    export let title;
    export let items = [];
    export let enableAdd = true;
    export let canZero = false;
    export let columns = [];

    let teamOptions = [[{label: 'Seleccione cargo', value: ''}]];

    onMount(() => {
        if (columns.length > 1) {
            for (const [index, item] of items.entries()) {
                addTeam(item.position, index, columns[0]);
            }
        }
    });

    function add() {
        teamOptions = [...teamOptions, [{label: 'Seleccione cargo', value: ''}]];
        items.push(columns.reduce((acc, item) => {
            acc[item.slug] = '';
            return acc;
        }, {}))
        items = [...items];
    }

    function del(i) {
        items.splice(i, 1);
        items = [...items];

        teamOptions.splice(i, 1);
        teamOptions = [...teamOptions];
    }

    function addTeam(value, index, col) {
        const selected = col.options.find(c => c.value === value);
        teamOptions[index] = selected ? selected.operators : [];
    }
</script>

<fieldset class="mb-2">
    <legend>{title}</legend>
    {#each items as item, i}
        <div class="box-l sx-15 my-1">
            <div>
                {i + 1}
            </div>
            {#each columns as col}
                {#if col.options}
                    <NauiSelect label={col.label} bind:value={item[col.slug]} options={col.options}
                                on:change={(ev) => {addTeam(ev.target.value, i, col)}}/>
                {:else}
                    <NauiSelect label={col.label} bind:value={item[col.slug]} options={teamOptions[i]}/>
                {/if}
            {/each}
            <div style="margin-top: 8px">
                {#if i > 0 || canZero}
                    <div class="trash-item" on:click={()=>{del(i)}}>
                        <i class="fal fa-trash-alt"></i>
                    </div>
                {/if}
            </div>
        </div>
    {/each}
    {#if enableAdd}
        <div class="mt-2 add-item" on:click={add}>
            <i class="ml-1 fal fa-plus mr-ii"></i>
            AÑADIR
        </div>
    {/if}
</fieldset>

<style>
    .trash-item {
        padding: .5rem .6rem;
        border: 1px solid #ccc;
        border-radius: 50%;
        cursor: pointer;
    }

    .trash-item i {
        color: var(--accent)
    }

    .add-item, .add-item i {
        cursor: pointer;
        color: var(--accent)
    }
</style>